import { AsyncAction } from '../../base-classes';
import { outdoorSportsProvider } from '../providers/outdoorSportsProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_OUTDOOR_SPORTS_SUMMARY_DATA = new AsyncAction('GET_OUTDOOR_SPORTS_SUMMARY_DATA');
export const GET_OUTDOOR_SPORTS_DETAIL_DATA = new AsyncAction('GET_OUTDOOR_SPORTS_DETAIL_DATA');
export const GET_OUTDOOR_SPORTS_LEGEND_DATA = new AsyncAction('GET_OUTDOOR_SPORTS_LEGEND_DATA');
//Type 'string' is not comparable to type 'AsyncAction'
export type ErrorType = {
    type: string;
    payload?: unknown;
}
export type GetOutdoorSportsSummaryActionType = {
    type: typeof GET_OUTDOOR_SPORTS_SUMMARY_DATA;
    payload: Promise<OutdoorSportsSummaryData>;
}

export type GetOutdoorSportsDetailActionType = {
    type: typeof GET_OUTDOOR_SPORTS_DETAIL_DATA;
    payload: Promise<OutdoorSportsDetailData>;
}

export type GetOutdoorSportsLegendActionType = {
    type: typeof GET_OUTDOOR_SPORTS_LEGEND_DATA;
    payload: Promise<OutdoorSportsLegendData>;
}

export function getOutdoorSportSummaryDataByLatLon(...params: OutdoorSportsSummary[]|any[]): GetOutdoorSportsSummaryActionType {
   
    let paramsObject = {
        latitude: '',
        longitude: '',
        baseUrl: '',
        authId: '',
        secret: '',
        stdParameters: '',
        verbose: false,
        isCached: false 
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    const outdoorSportsParam : OutdoorSportsSummary = paramsObject;

    return {
        type: GET_OUTDOOR_SPORTS_SUMMARY_DATA.base,
        payload: getOutdoorSportsSummaryData(outdoorSportsParam)
    };
}

export function getOutdoorSportDetailDataByLatLon(...params: OutdoorSportsDetail[]|any[]): GetOutdoorSportsDetailActionType {
    
    let paramsObject = {
        latitude: '',
        longitude: '',
        baseUrl: '',
        authId: '',
        secret: '',
        stdParameters: '',
        tempUnit: '',
        speedUnit: '',
        distanceUnit: '',
        verbose: false,
        isCached: false 
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    const outdoorSportsParam : OutdoorSportsDetail = paramsObject;

    return {
        type: GET_OUTDOOR_SPORTS_DETAIL_DATA.base,
        payload: getOutdoorSportsDetailData(outdoorSportsParam)
    };
}

export function getOutdoorSportLegendDataByLatLon(...params: OutdoorSportsSummary[]|any[]): GetOutdoorSportsLegendActionType {
    let paramsObject = {
        latitude: '',
        longitude: '',
        baseUrl: '',
        authId: '',
        secret: '',
        stdParameters: '',
        verbose: false,
        isCached: false 
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    const outdoorSportsParam : OutdoorSportsSummary = paramsObject;

    return {
        type: GET_OUTDOOR_SPORTS_LEGEND_DATA.base,
        payload: getOutdoorSportsLegendlData(outdoorSportsParam)
    };
}

export async function getOutdoorSportsSummaryData( { latitude , longitude , baseUrl , authId , secret , stdParameters , verbose, isCached } : OutdoorSportsSummary ) : Promise<OutdoorSportsSummaryData> {
    const op = new outdoorSportsProvider(baseUrl, authId, secret);
    return await op.getOutdoorSportsSummary(latitude , longitude , isCached , stdParameters , verbose);
}

export async function getOutdoorSportsDetailData( { latitude , longitude , baseUrl , authId , secret , stdParameters , tempUnit, speedUnit, distanceUnit, verbose, isCached } : OutdoorSportsDetail ) : Promise<OutdoorSportsDetailData>  {
    const op = new outdoorSportsProvider(baseUrl, authId, secret);
    return await op.getOutdoorSportsDetail(latitude, longitude, isCached, tempUnit, speedUnit, distanceUnit, stdParameters, verbose);
}

export async function getOutdoorSportsLegendlData( { latitude , longitude , baseUrl , authId , secret , stdParameters , verbose, isCached  } : OutdoorSportsSummary ) : Promise<OutdoorSportsLegendData>  {
    const op = new outdoorSportsProvider(baseUrl, authId, secret);
    return await op.getOutdoorSportsLegend(latitude, longitude, isCached, stdParameters, verbose);
}

export interface OutdoorSportsSummary {
    latitude: string;
    longitude: string;
    baseUrl: string;
    authId: string;
    secret: string;
    stdParameters: string;
    verbose: boolean;
    isCached: boolean;
}

export interface OutdoorSportsDetail extends OutdoorSportsSummary {
    distanceUnit: string;
    tempUnit: string;
    speedUnit: string;
}


export interface OutdoorSportsSummaryData {
    i: string;
    e: string;
    r: OutdoorSportsSummaryResult;
    c: number;  
}

export interface OutdoorSportsSummaryResult {
    st : OutdoorSportsSummaryCardInfo;
}

export interface OutdoorSportsSummaryCardInfo {
    sft: string;
    sfi: string;
    ind: number;
    il: string;
    cl: string;
}

export interface OutdoorSportsDetailData {
    i: string;
    e: string;
    r: OutdoorSportsDetailResult;
    c: number;  
}


export interface OutdoorSportsDetailResult{
    st : OutdoorSportsSummaryCardInfo;
    SafetyTip: OutdoorSportsSafetyTip;
    ki: OutdoorSportsKeyIndicators;
    ForecastRecords:OutdoorSportsForecastRecord[];
}

export interface OutdoorSportsSafetyTip{
    SafetyTips: string;
    SafetyIcon: string;
    IndexNumber: number;
    IndexLabel: string;
    Color: string;
}

export interface OutdoorSportsKeyIndicators{
    srdtu: string;
    srdtol: string;
    ssdtu: string;
    ssdtol: string;
    srds: string;
    ssds: string;
    flt: number;
    wbtm: number;
    wbtc: number;
    wbtds: string;
    wbd: string;
    iwbte: boolean;
    prcpp: number;
    hup: number;
    uvds: string;
    uvl: string;
    uvn: number;
    wds: string;
    wd: string;
    ws: number;
    wsuds: string;
}

export interface OutdoorSportsForecastRecord{
    in: number;
    cl: string;
    fi: number;
    tmp: number;
    prcpp: number;
    dth: number;
    dthds: string;
    dtdowds: string;
    oidtol: string;
    idt: true;
    dloc: true;
}

export interface OutdoorSportsLegendData {
    i: string;
    e: string;
    r: OutdoorSportsLegendDetailResult;
    c: number;  
}

export interface OutdoorSportsLegendDetailResult{
    osill : OutdoorSportsLegendDetails[];
}

export interface OutdoorSportsLegendDetails{
    ilmin: number;
    ilmax: number;
    ill: string;
    ilds: string;
    ile: string;
    ili: string;
    ilc: string;
}


